import axiosPost from '../axiosPost';

export const tiposDeDeviceDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "TipoDeviceDel",
        "params": { "tipoDeviceId": id }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}